/* Engravita v6 · the few behaviours the DNA needs.
   1. data-eg-engrave: a display headline is engraved in once, when it first enters the viewport.
   2. data-eg-reveal: a block rises into place once (stagger with style="--i:n").
   3. data-eg-index: the homepage category index shows the hovered category's photo beside the list.
   No scroll listeners; IntersectionObserver only. Under reduced motion the CSS shows everything at rest. */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  // viaParent: watch the parent instead, because a target clipped to nothing (the engraving's start state) never
  // reports as visible; several targets can share one parent
  const show = (sel, cls, opts, viaParent) => {
    const els = document.querySelectorAll(sel);
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(el => el.classList.add(cls)); return; }
    const map = new Map();
    els.forEach(el => { const w = viaParent ? el.parentElement : el; map.set(w, [...(map.get(w) || []), el]); });
    const io = new IntersectionObserver(entries => {
      for (const e of entries) if (e.isIntersecting) { map.get(e.target).forEach(el => el.classList.add(cls)); io.unobserve(e.target); }
    }, opts);
    map.forEach((_, w) => io.observe(w));
  };

  const init = () => {
    show('[data-eg-engrave]', 'is-engraved', { threshold: 0, rootMargin: '0px 0px -14% 0px' }, true);
    show('[data-eg-reveal]', 'is-in', { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });

    // FAQ page: every h3 in the body and the content up to the next heading become one question that opens
    document.querySelectorAll('[data-eg-faq]').forEach(root => {
      let cur = null;
      [...root.children].forEach(el => {
        if (el.tagName === 'H3') {
          cur = document.createElement('details');
          cur.className = 'eg-acc6__row';
          const s = document.createElement('summary');
          s.className = 'eg-acc6__q';
          s.innerHTML = '<span></span><span class="eg-acc6__chev" aria-hidden="true"><svg viewBox="0 0 256 256" width="18" height="18" fill="currentColor"><path d="M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z"/></svg></span>';
          s.firstChild.textContent = el.textContent;
          const a = document.createElement('div');
          a.className = 'eg-acc6__a';
          cur.append(s, a);
          el.replaceWith(cur);
        } else if (/^H[12]$/.test(el.tagName)) {
          cur = null;
        } else if (cur) {
          cur.lastChild.appendChild(el);
        }
      });
      root.classList.add('eg-acc6');
    });

    // category index: the photo follows the hovered or focused row (pointer devices only; touch gets the tile grid)
    document.querySelectorAll('[data-eg-index]').forEach(root => {
      const imgs = root.querySelectorAll('[data-eg-index-img]');
      const rows = root.querySelectorAll('[data-eg-index-row]');
      const pick = i => {
        imgs.forEach((im, j) => im.classList.toggle('is-on', j === i));
        rows.forEach((r, j) => r.classList.toggle('is-on', j === i));
      };
      rows.forEach((r, i) => { r.addEventListener('pointerenter', () => pick(i)); r.addEventListener('focus', () => pick(i)); });
    });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
